import { render, staticRenderFns } from "./PricingBotEmptyState.vue?vue&type=template&id=5678badc&"
import script from "./PricingBotEmptyState.vue?vue&type=script&lang=js&"
export * from "./PricingBotEmptyState.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports